import { render, staticRenderFns } from "./TheStartAccountDeletionProcessView.vue?vue&type=template&id=5ec316dc&scoped=true"
import script from "./TheStartAccountDeletionProcessView.vue?vue&type=script&lang=js"
export * from "./TheStartAccountDeletionProcessView.vue?vue&type=script&lang=js"
import style0 from "./TheStartAccountDeletionProcessView.vue?vue&type=style&index=0&id=5ec316dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec316dc",
  null
  
)

export default component.exports